import React from 'react';
import clsx from 'clsx';
import { Typography, getTypographyDefaultColor, Container } from '@ag1/ui';

import { CenterCallOut as CenterCallOutProps, SanityBlock, SanityKeyed } from 'types/studio/studio';
import { getThemeCSSClass } from 'shared/utils/getThemeCSSClass';
import CustomPortableText from '../PortableText/PortableText';
import styles from './CenterCallOut.module.scss';
import { StudioBaseIconV2 } from '../StudioBaseIcon/StudioBaseIcon';
import { CommonSectionProps } from '../types';

const CenterCallOut = ({
  _key: key,

  text,
  icon,
  iconLocation,
  theme
}: SanityKeyed<CenterCallOutProps> & CommonSectionProps) => {
  type Variant = 'normal' | 'h2' | 'h3' | 'h4';

  const getFontVariant = (txt: (SanityBlock & { _key: string })[] | { style: any }[]): any => {
    const textStyle: Variant = txt[0].style;
    const variantMap = {
      h2: 'headlineSans',
      h3: 'headlineSans',
      h4: 'subtitle',
      normal: 'body'
    };
    const variant = variantMap[textStyle];
    return variant;
  };

  const getFontSize = (txt: (SanityBlock & { _key: string })[] | { style: any }[]): any => {
    const textStyle: Variant = txt[0].style;
    const sizeMap = {
      h2: '1',
      h3: '3',
      h4: '2',
      normal: '1'
    };
    const variant = sizeMap[textStyle];
    return variant;
  };

  return (
    <Container narrow className={clsx(styles['center-call-out-container'])}>
      <div className={clsx(styles.col, getThemeCSSClass(theme), styles.bgStone)} id={key}>
        {iconLocation === 'middle' && (
          <div className={clsx(styles.commonShift, styles[`text-${iconLocation}`])}>
            {icon?.asset && <StudioBaseIconV2 icon={icon} className={styles.icon} />}
          </div>
        )}

        <div
          className={clsx(
            styles.flex,
            styles['items-center'],
            styles['justify-center'],
            iconLocation === 'right' && styles['row-reverse']
          )}>
          {iconLocation !== 'middle' && (
            <div className={clsx(styles.commonShift, styles[`text-${iconLocation}`])}>
              {icon?.asset && <StudioBaseIconV2 icon={icon} className={styles.icon} />}
            </div>
          )}

          {text && (
            <Typography
              component="div"
              className={clsx(
                styles.commonShift,
                styles.text,
                styles[`text-${iconLocation || 'left'}`]
              )}
              color={getTypographyDefaultColor(theme)}
              noPadding
              size={getFontSize(text)}
              variant={getFontVariant(text)}>
              <CustomPortableText value={text} />
            </Typography>
          )}
        </div>
      </div>
    </Container>
  );
};

export default CenterCallOut;
